import { simpleSet } from '@r/reducers/utils';

const setCabinetSetMaterialOnDoorOrBody = simpleSet as
  redux.reducers.flags.cabinetSetMaterialOnDoorOrBody;

export const cabinetSetMaterialOnDoorOrBody = setCabinetSetMaterialOnDoorOrBody(
  'SET_CABINET_SET_MATERIAL_ON_DOOR_OR_BODY',
  'body'
);
